module.exports = __webpack_public_path__ + "assets/media/2.e25884bd.wav";